import { Component, inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WordPressProfileService } from './profile.service';
import { NavBarItem } from '../../shared/components/nav-bar/nav-bar.interface';
import { Login } from './interfaces/profile.interface';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  private wordPressProfileService = inject(WordPressProfileService);
  private panelStateSubscription!: Subscription;
  private profileSubscription!: Subscription;

  public isPanelOpen = false;
  public profileNavBarItems: NavBarItem[] | null = null;


  public userName: string;
  public userProfileImage: string;
  public userRole: string;

  ngOnInit(): void {
    this.getProfileMenuItems();
    this.getUserProfileInfo();
  }

getUserProfileInfo(): void {
  this.wordPressProfileService.loadUserProfile().subscribe({
    next: (profile: Login) => {
      console.log(' PROFILE CARGADO', profile);
      this.userName = profile.user_data.display_name;
      this.userProfileImage = profile.user_data.profile_image;
      this.userRole = profile.user_data.job_title;
    },
    error: (err) => {
      console.error('Error al cargar el perfil:', err);
    }
  });
}



  private getProfileMenuItems(): void {
    this.profileSubscription = this.wordPressProfileService.perfilMenuItems$.subscribe(
      (profileNavBarItems) => {
        this.profileNavBarItems = profileNavBarItems;
      }
    );

    this.panelStateSubscription = this.wordPressProfileService.isPanelOpen$.subscribe(
      (isOpen) => {
        this.isPanelOpen = isOpen;
      }
    );
  }

  ngOnDestroy(): void {
    this.profileSubscription?.unsubscribe();
    this.panelStateSubscription?.unsubscribe();
  }

  closePanel(): void {
    this.wordPressProfileService.closePanel();
  }
}
